import Axios from "axios";
import router from "./../../router/index";

// state
const state = {
  isLoading: false,
  isLoggedIn: -1,
  userName: "",
  userEmail: "",
  hasPages: false,
  isMobile: false,
  isPortrait: false,
  hideGraphs: false
};

// getters
const getters = {
  isUserLoggedIn(state: any) {
    return state.isLoggedIn;
  }
};

// actions
const actions = {
  getUserName({ commit }: any) {
    Axios.get("/api/v1/username")
      .then((response) => {
        commit("UPDATE_USERNAME", response.data.name);
        commit("UPDATE_USERMAIL", response.data.email);
        commit("UPDATE_SHOW_PAGES", response.data.hasPages);
      })
      .catch((error) => {
        if (error.response.status == 401) {
          router.push("/login");
        }
      });
  },
  async checkIfUserIsLoggedIn({ commit }: any) {
    await Axios.get("/api/v1/checkLogin")
      .then((response) => {
        const isLoggedIn = response.data.loggedin;
        commit("IS_USER_LOGGED", isLoggedIn);
      })
      .catch(() => {
        commit("IS_USER_LOGGED", false);
      });
  },
  logoutUser({ commit }: any) {
    commit("IS_USER_LOGGED", false);
    router.push("/login");
  },
  setLoadingStatus({ commit }: any, status: boolean) {
    commit("SET_LOADING_STATUS", status);
  },
  async checkIfIsMobile({ commit }: any) {
    const height = window.innerHeight;
    const width = window.innerWidth;
    const IsMobile = width <= 600 || height <= 600;
    const IsPortrait = height >= width;
    commit("UPDATE_MOBILE_STATUS", IsMobile);
    commit("UPDATE_ORIENTATION", IsPortrait);
  },
  async setShowGraph({ commit }: any, status: boolean) {
    commit("UPDATE_SHOWGRAPHS", status);
  }
};

// mutations
const mutations = {
  UPDATE_USERNAME(state: any, name: string) {
    state.userName = name;
  },
  UPDATE_USERMAIL(state: any, email: string) {
    state.userEmail = email;
  },
  IS_USER_LOGGED(state: any, status: boolean) {
    state.isLoggedIn = status;
  },
  SET_LOADING_STATUS(state: any, status: boolean) {
    state.isLoading = status;
  },
  UPDATE_MOBILE_STATUS(state: any, status: boolean) {
    state.isMobile = status;
  },
  UPDATE_ORIENTATION(state: any, status: boolean) {
    state.isPortrait = status;
  },
  UPDATE_SHOWGRAPHS(state: any, status: boolean) {
    state.hideGraphs = status;
  },
  UPDATE_SHOW_PAGES(state: any, status: boolean) {
    state.hasPages = status;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
